import React, { Component } from 'react';
import {
    EditorState, EditorBlock, Modifier, SelectionState,
} from 'draft-js';
import { CALLOUT_COLORS } from '../utilities/CONSTANTS';

const DEFAULT_COLOR = CALLOUT_COLORS.blue;

const ColorSwitcher = (props) => {
    const onSelect = (e) => {
        e.stopPropagation();
    };

    const selectColor = (e) => {
        const { editorState, setEditorState } = props.blockProps;
        const blockSelection = SelectionState.createEmpty(props.block.getKey());

        setEditorState(
            EditorState.push(
                editorState,
                Modifier.setBlockData(
                    editorState.getCurrentContent(),
                    blockSelection,
                    { color: e.target.value },
                ),
            ),
        );
    };

    const { color } = props.blockProps;
    const value = color || DEFAULT_COLOR;
    const label = CALLOUT_COLORS[value] || DEFAULT_COLOR;

    return (
        <div onInput={e => e.stopPropagation()}>
            <div
                className="callout-color-switcher"
                contentEditable={false}
            >
                <label htmlFor="color-select">
                    {label}
                    <span className="dropdown-carat" />
                </label>
                <select
                    name="color-select"
                    value={value}
                    onChange={selectColor}
                >
                    {Object.keys(CALLOUT_COLORS).map((color, index) => (
                        <option key={color} value={color}>{CALLOUT_COLORS[color]}</option>
                    ))}
                </select>
            </div>
        </div>
    );
};

const Code = (props) => {
    const { color = DEFAULT_COLOR } = props.blockProps;
    return (
        <div className={`callout-block callout-${color}`}>
            <EditorBlock {...props} />
            {!props.blockProps.readOnly && <ColorSwitcher {...props} />}
        </div>
    );
};

export default Code;
